import useCurrentEventInfo from '@contexts/useCurrentEventInfo';
import useDisconnectOrLeaveRoom from '@hooks/useDisconnectOrLeaveRoom';
import AvAccessButton from '@molecules/AvAccessButton';
import {
  useGetCurrentAuctionRound,
  useSelectHighestBidder,
} from '@queries/auctions';
import { useCreateExtension } from '@queries/extensions';
import { useGetRoom } from '@queries/rooms';
import { useCreateTokenTransaction } from '@queries/tokens';
import {
  Admin,
  Button,
  ButtonVariants,
  MediaDeviceType,
  NonNative,
  TextInput,
} from '@sunrise-ui/primitives';
import React, { useState } from 'react';
import { View } from 'react-native';

export default function SettingsSideBar() {
  const { currentRoomId } = useCurrentEventInfo();
  const { mutate: createExtension } = useCreateExtension();
  const { mutate: addTokens, isPending: isPendingTokens } =
    useCreateTokenTransaction();
  const { mutate: selectHighestBidder, isPending: isPendingAuction } =
    useSelectHighestBidder();
  const [tokensToAdd, setTokensToAdd] = useState('');
  const disconnectOrLeaveRoom = useDisconnectOrLeaveRoom();
  const { data: round } = useGetCurrentAuctionRound();
  const { data: room } = useGetRoom(currentRoomId);

  return (
    <View style={{ padding: 20, gap: 20 }}>
      <Admin>
        <Button
          onPress={() => {
            createExtension();
          }}
          variant={ButtonVariants.PURPLE}
        >
          Create extension
        </Button>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 20 }}>
          <TextInput
            label="Add tokens"
            showLabel={false}
            value={tokensToAdd}
            onChange={(text) => {
              setTokensToAdd(text);
            }}
          />
          <Button
            onPress={() => {
              addTokens(
                { quantity: parseInt(tokensToAdd, 10) },
                {
                  onSuccess: () => {
                    setTokensToAdd('');
                  },
                },
              );
            }}
            variant={ButtonVariants.PINK}
            disabled={isPendingTokens}
            loading={isPendingTokens}
          >
            {isPendingTokens ? '' : 'Add Tokens'}
          </Button>
        </View>
        <Button
          onPress={() => {
            if (round && room)
              selectHighestBidder({
                userId: room.user_id,
                roundId: round.round_id,
              });
          }}
          variant={ButtonVariants.PURPLE}
          disabled={isPendingAuction}
          loading={isPendingAuction}
        >
          {isPendingAuction ? '' : 'Select Highest Bidder'}
        </Button>
      </Admin>
      <Button onPress={disconnectOrLeaveRoom} variant={ButtonVariants.PURPLE}>
        Leave room
      </Button>
      <NonNative>
        <AvAccessButton variant={MediaDeviceType.CAMERA} />
        <AvAccessButton variant={MediaDeviceType.MICROPHONE} />
      </NonNative>
    </View>
  );
}
